import { Theme } from "@emotion/react";

import { diadocCandyTheme } from "./DiadocCandyTheme";

export const logisticsCandyTheme: Theme = diadocCandyTheme;
